/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsvoid1Inputs */

const en_ticketsvoid1 = /** @type {(inputs: Ticketsvoid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Void`)
};

const de_ticketsvoid1 = /** @type {(inputs: Ticketsvoid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültig machen`)
};

/**
* | output |
* | --- |
* | "Void" |
*
* @param {Ticketsvoid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsvoid1 = /** @type {((inputs?: Ticketsvoid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsvoid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsvoid1(inputs)
	return de_ticketsvoid1(inputs)
});
export { ticketsvoid1 as "ticketsVoid" }